import React, { useState, useEffect, useRef } from "react";
import { Col, Container } from "react-bootstrap";
import Message from "./message.jsx";
import {saveDocxArray} from "./save.jsx";

function MessageWithCol({ height, message, timeStamp, speaker = 'Unknown', onConversationsUpdate, saveSpeech, onSaved }) {
  const [messages, setMessages] = useState([]); // 将初始值设置为空数组
  const messagesEndRef = useRef(null);
  const [conversations, setConversations] = useState([]);

  useEffect(() => {
    if (saveSpeech && messages.length > 0) {
        // 在这里执行保存操作
        const messageJson = JSON.stringify(messages)

        const textContent = messages.map((item) => {
          const { user, timestamp, message } = item;
          return `${timestamp}\n${user}：\n${message}\n\n`;
        });

        saveDocxArray("meeting", textContent);
    
        // 保存操作完成后，调用 onSaved 回调以将状态重置为 false
        if (onSaved) {
            onSaved();
        }
    }
  }, [saveSpeech, onSaved]);

  // 添加新消息的函数
  const addMessage = (newMessage, newUser) => {
    // 创建新的消息对象
    const newMsg = {
      message: newMessage,
      timestamp: timeStamp,
      user: newUser,
    };

    // 将新消息添加到 messages 数组
    setMessages([...messages, newMsg]);    
  };

  // 添加 JSON 对象到数组的函数
  const addConversation = (conversation) => {
    setConversations((prevConversations) => {
      const updatedConversations = [...prevConversations, conversation];

      return updatedConversations;
    });
  };

  
  // 当 conversations 更新时，调用父组件的回调函数
  useEffect(() => {
    if (conversations.length > 0) {
      onConversationsUpdate(conversations);
    }
  }, [conversations]);

  useEffect(() => {
    if (message) { // 添加条件以防止空消息被添加
      addMessage(message, speaker);
    }
  }, [message]); // 注意这里的依赖项数组

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
    }

    // 创建 conversation 对象并添加到 conversations 数组
    if (messages.length > 0) {
      const lastMessage = messages[messages.length - 1];
      const conversation = {
        message: lastMessage.message,
        user: lastMessage.user,
        time: lastMessage.timestamp,
      };
      addConversation(conversation);
    }
  }, [messages]);

  return (
    <Col style={{ height: height }}>
      <main className="main is-visible" data-dropzone-area="">
        <Container className='h-100'>
          <div className='d-flex flex-column h-100 position-relative'>
            <div className="chat-body flex-1 h-100">
              <div className="chat-body-inner" ref={messagesEndRef}>
                <div className="py-6 py-lg-12">
                  {messages.map((msg, index) => (
                    <Message
                      key={index}
                      message={msg.message}
                      timestamp={msg.timestamp}
                      user={msg.user}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </main>
    </Col>
  );
}

export default MessageWithCol;